import { useTranslation } from '../i18n';
import React from 'react';
import { Tag } from 'antd';
import { resolveStatus } from '../constants/statusDictionary';

/**
 * 统一状态标签：<StatusTag status="pending_validation" domain="cert" />
 * 字典见 shared/constants/statusDictionary.js。
 */
const StatusTag = ({ status, domain, style }) => {
    const { t } = useTranslation();
    const { label, color } = resolveStatus(status, domain);
    return <Tag color={color} style={{ marginInlineEnd: 0, ...style }}>{t(label)}</Tag>;
};

export default StatusTag;
